import React from 'react'
import { Card, makeStyles, mergeClasses, Spinner, tokens } from '@fluentui/react-components'
const useStyles = makeStyles({
   beige: {
      backgroundColor: tokens.colorPaletteMarigoldBackground1,
   },
   blue: {
      backgroundColor: tokens.colorBrandBackground,
   },
   card: {
      boxShadow: tokens.shadow8,
      padding: `${tokens.spacingVerticalXXL}`,
      borderRadius: tokens.borderRadiusXLarge,
      ':hover': {
         backgroundColor: 'none',
      },
   },
   bigCard: {
      height: '700px',
      '@media screen and (max-width: 1007px)': { height: 'auto' },
   },
   resetCss: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '@media screen and (max-width: 1450px)': {
         boxShadow: 'none',
         backgroundColor: 'transparent',
         height: 'auto',
         padding: 0,
      },
   },
   height100: {
      height: '100%',
   },
})

type DashboardCardProps = {
   color: 'beige' | 'blue'
   bigCard?: boolean
   children?: JSX.Element
   onClick?: () => void
   className?: string
   resetCss?: boolean
   height100?: boolean
   loading?: boolean
}
export const DashboardCard = ({ color, bigCard, children, onClick, className, resetCss, height100, loading }: DashboardCardProps) => {
   const classes = useStyles()
   return (
      <Card
         className={mergeClasses(
            color === 'blue' ? classes.blue : classes.beige,
            classes.card,
            bigCard ? classes.bigCard : '',
            height100 ? classes.height100 : '',
            resetCss ? classes.resetCss : '',
            className ? className : ''
         )}
         onClick={onClick}
      >
         {loading ? (
            <Spinner style={{ margin: 'auto' }} />
         ) : (
            children
         )}
      </Card>
   )
}
